<template lang="pug">
div
  label オーバーレイ
  select.form-control(v-model='selectedId')
    option(:value="''") 選択してください
    option(
      v-for='overlay in overlayOptions',
      :key='overlay.id',
      :value='String(overlay.id)'
    ) {{ overlayLabel(overlay) }}
</template>

<script>
export default {
  props: {
    overlays: {
      type: Array,
      default: () => []
    },
    value: {
      default: ''
    }
  },
  computed: {
    selectedId: {
      get() {
        if (this.value === null || this.value === undefined || this.value === '') {
          return ''
        }
        return String(this.value)
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    overlayOptions() {
      const overlays = this.overlays || []
      const selectedId = this.selectedId
      if (!selectedId) {
        return overlays
      }
      const exists = overlays.some((overlay) => String(overlay.id) === selectedId)
      if (exists) {
        return overlays
      }
      return [
        {
          id: selectedId,
          name: '削除済みまたは別ドメイン',
          position_rb: false
        },
        ...overlays
      ]
    }
  },
  methods: {
    overlayLabel(overlay) {
      const position = overlay.position_rb ? '（右下）' : '（画面下）'
      const name = overlay.name || ''
      return `ID:${overlay.id} ${name}${position}`
    }
  }
}
</script>
